<div class="filter-wrapper">
  <div class="view-by">
    <div class="view-by__dropdown">
      <div class="dropdown-container">
        <mat-form-field class="mat-select-field" floatLabel="never" appearance="outline">
          <mat-select
            hideSingleSelectionIndicator="true"
            panelClass="custom-dropdown"
            [value]="selectedView"
            (selectionChange)="onViewChange($event.value)"
          >
            <mat-option *ngFor="let view of viewOptions" [value]="view.key">
              {{ view.value | xTranslate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="filter-legend">
    <div class="legend-item" *ngFor="let filter of displayFilterOptions | updateUnaccountedFilter">
      <button
        mat-flat-button
        class="colorbutton"
        [ngClass]="[selectedFilters[filter.id] ? filter.class + '__hide' : filter.class]"
        (click)="onFilterSelection(filter.id)"
      ></button>
      <div class="legend-item__details">
        <div class="item-label">{{ filter.key ? filter.key : filter.label }}</div>
        <div class="item-value">
          {{ filter.spaceArea | formatNumber }}
          {{ filter.spaceAreaUOM ?? 'SF' | abbrevUom }}
          ({{ filter.spacePercent ?? 0 | percent: '1.1-1' }})
        </div>
      </div>
    </div>
    <div *ngIf="displayShowMore" class="show-more">
      <a *ngIf="showMore; else showless" (click)="hideShowFilters(false)">{{ 'filters.brand.seeLess' | xTranslate }}</a>
    </div>
    <ng-template #showless>
      <a (click)="hideShowFilters(true)">{{ 'filters.brand.seeMore' | xTranslate }}</a>
    </ng-template>
  </div>
</div>
